import type { Theme } from './ThemeContext';

/** Shared with the blocking inline script in index.html — keep the literal key in sync with it. */
export const STORAGE_KEY = 'epn-theme';

function isTheme(value: string | null): value is Theme {
  return value === 'light' || value === 'dark';
}

/**
 * A saved choice always wins. The OS/browser preference is consulted only when nothing has been saved
 * yet — it is the initial default, not an ongoing override (see ThemeProvider's doc comment).
 */
export function readStoredTheme(): Theme {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (isTheme(saved)) {
      return saved;
    }
  } catch {
    // Private-browsing/storage-disabled — fall through to the OS preference for this load.
  }
  const prefersDark = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
  return prefersDark ? 'dark' : 'light';
}
